import { themedUseStyletron } from '../../../theme/customTheme'
import { Input } from "baseui/input";
import { ValueDisplay } from '../../components/ValueDisplay'
import { IDriveVarSpeed } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import {  StatefulOperationModeSelect } from '../Aggregate';
import { OperationState } from "../OperationState";
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { DriveIcon, DriveIconSimple } from '../DriveBase/DriveIcon';
import { AggregateOnOffText } from '../Aggregate';
import { MdSpeed } from 'react-icons/md';

export function OverviewPanel(props: IDriveVarSpeed) {
    const [, theme] = themedUseStyletron();

    const [setSpeed, setSetSpeed, setSetSpeedResult] = useSetObjectValue(props.id, props.resourceGroupId, "setSpeed", props.setSpeed);
    const onSetSpeedChanged = (e: any) => setSetSpeed(parseFloat(e.target.value));

    return (
        <OverviewPanelWrapper {...props} icon={<DriveIconSimple schema={props.schema} color={theme.colors.backgroundPrimary} size='100%' />}>
            <>
                <DriveIcon isOn={props.isOn} schema={props.schema} color={props.isOn ? theme.appColors.aggregate.on : theme.appColors.aggregate.off} size='40px' />
                <AggregateOnOffText {...props}></AggregateOnOffText>
                <ValueDisplay value={props.actSpeed ? props.actSpeed : props.setSpeed} dimension='%'></ValueDisplay>
            </>
            <StatefulOperationModeSelect isCompact {...props}  onSwitchManOff={() => setSetSpeed(0)} onSwitchManOn={() => setSetSpeed(100)}></StatefulOperationModeSelect>
            {props.isWriteable && <Input
                value={setSpeed?.toFixed(0)}
                onChange={onSetSpeedChanged}
                type='number'
                endEnhancer={'%'}
                startEnhancer={<MdSpeed></MdSpeed>}
                disabled={setSetSpeedResult.isLoading || props.state === OperationState.Auto}
                overrides={{
                    Root: {
                        style: {
                            width: '70%',
                        },
                    },
                }}
            />}

        </OverviewPanelWrapper>
    );
}